<template>
  <v-layout
    align-center
    justify-center
    row
    fill-height
  >
    <v-flex
      xs6
      class="justify-center">
      <h4 class="text-capitalize mt-5 py-3 font-weight-regular text-xs-center">
        {{ $t('Create your first store') }}
      </h4>
      <v-flex
        xs12
        class="my-4 justify-center"
      >
        <add-new-store-form
          :show="true"
          class="py-4"
          @postCreationAction="redirect"
        />
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import AddNewStoreForm from '@/modules/Settings/components/AddNewStoreForm'

export default {
  name: 'StoreInstaller',

  components: {
    AddNewStoreForm
  },

  methods: {
    redirect () {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>
